module.exports = __webpack_public_path__ + "public/images/eagle.cbb7a1371eb3bf2415fa8dccf94fd2f9.svg";